export default __webpack_public_path__ + "static/media/4948@3x.bffc11c7.png";